import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home, Services, About, MosqueVision } from "./components";

import React, { useEffect } from 'react';
import { FaApplePay, FaGooglePay } from 'react-icons/fa';

const ZeffyDonationPanel = () => {
  useEffect(() => {
    // Only add the script if it hasn't been added yet
    if (!document.querySelector('script[src="https://www.zeffy.com/embed/v2/zeffy-embed.js"]')) {
      const script = document.createElement('script');
      script.src = "https://www.zeffy.com/embed/v2/zeffy-embed.js";
      script.async = true;
      script.onerror = () => {
        document.querySelectorAll('[data-zeffy-embed-fallback]').forEach(el => {
          el.style.display = 'block';
        });
      };
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section id="donation" className="bg-brand-cream relative z-20 py-8 md:py-10 md:-mt-24 px-4 md:px-6">
      <div className="max-w-6xl mx-auto bg-white shadow-[0_20px_50px_rgba(0,0,0,0.08)] rounded-xl border border-gray-100 overflow-hidden flex flex-col">
        
        {/* Thermometer Tracker Section */}
        <div className="bg-brand-green/5 border-b border-brand-green/10 py-4 px-4 md:py-5 md:px-8 flex flex-col items-center">
          <h2 className="text-xl md:text-2xl font-serif text-brand-green mb-1 text-center">Campaign Progress</h2>
          <div className="w-full max-w-4xl h-[100px]">
            <iframe 
              title='Donation form powered by Zeffy' 
              style={{ border: 0, width: '100%', height: '100%' }} 
              src='https://www.zeffy.com/embed/thermometer/support-iunity'  
              allowTransparency="true"
            ></iframe>
          </div>
        </div>

        {/* Form Section */}
        <div className="p-4 md:p-6 bg-[#f0fbff]">
          <div data-zeffy-embed data-form-url="/embed/donation-form/support-iunity"></div>
          <div data-zeffy-embed-fallback style={{ display: 'none' }}>
            <div style={{ position: 'relative', overflow: 'hidden', height: '450px', width: '100%' }}>
              <iframe 
                title='Donation form powered by Zeffy' 
                style={{ position: 'absolute', border: 0, top: 0, left: 0, bottom: 0, right: 0, width: '100%', height: '100%' }} 
                src='https://www.zeffy.com/embed/donation-form/support-iunity' 
                allow="payment" 
                allowTransparency="true"
              ></iframe>
            </div>
          </div>

          {/* Mobile Wallet External Link */}
          <div className="mt-4 pt-4 flex flex-col items-center justify-center">
            <p className="text-xs md:text-sm font-sans text-gray-500 text-center">Using Apple Pay or Google Pay? For the best experience, use our direct link.</p>
            <a 
              href="https://www.zeffy.com/en-CA/donation-form/support-iunity" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center mt-2 mb-2 gap-2 bg-black text-white hover:bg-gray-800 transition-colors px-5 py-2.5 rounded-full font-sans text-sm font-semibold shadow-md"
            >
              <FaApplePay className="text-3xl" />
              <span className="text-gray-400">/</span>
              <FaGooglePay className="text-3xl" />
              <span className="ml-2 border-l border-gray-600 pl-3">Donate via Wallet</span>
            </a>
          </div>
        </div>

      </div>
    </section>
  );
};

// Main page component
const MainPage = () => (
  <div className="min-h-screen bg-brand-cream overflow-x-hidden font-sans">
    <Home />
    {/* <Donation /> */}
    
    <ZeffyDonationPanel />

    <MosqueVision />
    <Services />
    <About />
  </div>
);

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPage />} />
      </Routes>
    </Router>
  );
}

export default App;
